module.exports = __webpack_public_path__ + "static/media/partner.6083f11e.png";